import { createWithEqualityFn } from 'zustand/traditional';

export interface ArtifactEntry {
  id: string;
  title: string;
}

export interface ArtifactsStore {
  artifacts: ArtifactEntry[];
  currentArtifact: {
    artifactId?: string;
    versionId?: string;
    title?: string;
  };
  error: string | null;
  isLoading: boolean;
  addArtifact: (artifact: ArtifactEntry) => void;
  setArtifacts: (artifacts: ArtifactEntry[]) => void;
  setCurrentArtifact: (
    currentArtifact: ArtifactsStore['currentArtifact']
  ) => void;
  setError: (error: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const useArtifactsStore = createWithEqualityFn<ArtifactsStore>(
  (set) => ({
    artifacts: [],
    currentArtifact: {},
    error: null,
    isLoading: true,
    addArtifact: (artifact) =>
      set((state) =>
        state.artifacts.some((item) => item.id === artifact.id)
          ? state
          : { artifacts: [artifact, ...state.artifacts] }
      ),
    setArtifacts: (artifacts) => set({ artifacts }),
    setCurrentArtifact: (currentArtifact) => set({ currentArtifact }),
    setError: (error) => set({ error }),
    setIsLoading: (isLoading) => set({ isLoading })
  })
);
